import { defineStore, storeToRefs } from 'pinia'
import { ref, computed } from 'vue'

import { useSfAssistantChecksReadStatus } from '@app/application/sf-assistant-checks/stores/assistant-checks-read-status'
import type { Check } from '../types'
import { useSfAssistantChecksPage } from './page'
import { useChecksStore } from './checks'

export const useAssistantChecksStore = defineStore('assistantChecks', () => {
  const isFromAssistantPage = ref<boolean>(false)

  const assistantChecksReadStatusStore = useSfAssistantChecksReadStatus()
  const { markChecksAsRead } = assistantChecksReadStatusStore
  const { checkReadStatus, checkReadByUsers } = storeToRefs(
    assistantChecksReadStatusStore
  )

  const assistantChecks = computed(() => {
    let store
    let assistantChecks

    if (isFromAssistantPage.value) {
      store = useSfAssistantChecksPage()
      const { checksById } = storeToRefs(store)

      assistantChecks = checksById.value
    } else {
      store = useChecksStore()

      const { checks } = storeToRefs(store)
      assistantChecks = checks.value.reduce((acc, check) => {
        acc[check.id] = check
        return acc
      }, {} as Record<string, Check>)
    }

    return assistantChecks
  })

  function initFromPageStore(): void {
    isFromAssistantPage.value = true
  }

  function initFromChecksStore(): void {
    isFromAssistantPage.value = false
  }

  return {
    assistantChecks,
    initFromPageStore,
    initFromChecksStore,
    markAsRead: markChecksAsRead,
    checkReadStatus,
    checkReadByUsers,
  }
})
